import React from "react";
import { Link, useLocation } from "react-router-dom";

const BreadCrumb = () => {
  const { pathname } = useLocation();

  let path_arr = pathname.split("/").filter((str) => str !== "");
  let path_url = [];
  let url = "/";

  path_arr.forEach((item) => {
    url += item + "/";
    path_url.push(url);
  });

  return (
    <div className="flex items-center gap-2 breadcrumb [&>*:first-child]:font-semibold [&>*:last-child]:pt-[7px]">
      {path_arr.map((item, index) => (
        <div
          className="capitalize text-sm flex items-center gap-2" 
          key={index}
        >
          <Link
            to={
              path_url[index] === "/updateStatus/" ||
              path_url[index] === "/accept-quote/" ||
              path_url[index] === "/accept-order/"
                ? "/quotes"
                : path_url[index] === "/dispute-details/"
                ? "/support"
                : path_url[index] === "/requestDetails/"
                ? "/requests"
                : path_url[index] === "/request/generateQuote/"
                ? "/requests"
                : path_url[index] === "/request/"
                ? "/requests"
                : path_url[index] === "/updateprofile/" 
                ? "/users"
                : path_url[index] === "/disputes/"
                ? "/users"
                : path_url[index]
            }
            className="text-blue-950 hover:underline"
          >
            {item}
          </Link>
          {index !== path_arr.length - 1 && (
            <span className="text-lg font-semibold text-blue-950">/</span>
          )}
        </div>
      ))}
      <div className="flex items-center gap-2">
      </div>
    </div>
  );
};

export default BreadCrumb;
